require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es6.array.species.js
// module id = 254
// module chunks = 0